import { cn } from "@/lib/utils";
import type { SearchOptionProps } from "./types";

export const NullOption = ({
  option,
  isSelected,
  onClick,
}: SearchOptionProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-accent/20 transition-colors",
        isSelected && "bg-primary/10 text-primary!"
      )}
    >
      <div className="flex size-8 items-center justify-center rounded-md border" />
      <div
        className={cn(
          "flex-1 truncate text-sm font-medium",
          isSelected && "text-primary!"
        )}
      >
        {option.title}
      </div>
    </div>
  );
};
